// Re-export from core — this file exists for backward compatibility during migration
export { default, sanitizeForLog, setVerbose, setChatMode, pushPipe, popPipe } from './logger.js'
